<template>
  <LayoutContent>
    <AcknowledgementCard :title="$t('message.yourConversionWasSuccessful')" :body="$t('message.pleaseCheckYourOlyWallet')" />
  </LayoutContent>
</template>

<script>
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import AcknowledgementCard from '@/components/AcknowledgementCard.vue'

export default {
  name: 'ConvertPointAcknowledgement',
  components: { LayoutContent, AcknowledgementCard }
}
</script>
